// Helpers
import { isLastValid, isValidMatrixRange } from "@/Common/helpers/Matrices/tiers";

const isSomeConfiguredModel = (content) => {
	const { makes = [] } = content || {};
	if (!makes?.length) {
		return true;
	}
	return makes?.some((item) => {
		const isMatrixInRange = isValidMatrixRange(item?.tiers || [], { column: "bonuses" });
		const isValidLast = isLastValid(item?.tiers || [], { column: "bonuses", reference: "bonus" });
		return isMatrixInRange && isValidLast;
	});
};

export { isSomeConfiguredModel };
